import { useQueryGrid } from '@gogame/query';

import { loadDepartments } from 'scenes/Users/AdminUsers/Departments/sources/departments';

import { grids } from './queryKeyFactory';

export const useLoadDepartments = () => {
  return useQueryGrid(grids(), (_, { signal }) =>
    loadDepartments({}, { signal })
  );
};
